import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {NavLink} from "react-router-dom";

import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import green from '@material-ui/core/colors/green';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import GetAppIcon from '@material-ui/icons/GetApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '@material-ui/core/LinearProgress';

import SortableList from '../utils/SortableList'
import FormDialog from '../utils/FormDialog'

import moment from 'moment';

import 'moment/locale/fr';
moment.locale('fr');

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  media: {
    marginTop: theme.spacing.unit * 2,
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 3,
  },
  progress: {
    marginBottom: 20,
  }
});

class Report extends React.Component {

  render() {
    const buttonClassname = classNames({
      [this.props.classes.buttonSuccess]: this.props.downloaded,
    });

    return (
      <React.Fragment>
        <CssBaseline />
        {!this.props.dataLoaded && (
            <div className={this.props.classes.progress}>
                <LinearProgress />
            </div>
        )}
        <NavLink to={"/reports/"} style={{ textDecoration: 'none' }}>
          <Button variant="outlined" size="large" >Retour</Button>
        </NavLink>


        {'audit' in this.props.report && (<Typography variant="title" gutterBottom>
          {"Rapport d'audit de l'entreprise : "} <NavLink to={"/audits/" + this.props.report.audit.id} style={{ textDecoration: 'none' }}><Button variant="outlined">{this.props.report.audit.company.name}</Button></NavLink>
        </Typography>)}

        {this.props.dataLoaded && (
          <Grid container spacing={24}>

          <Grid item xs={12} sm={12} md={6}>
            <Card className={this.props.classes.card}>
              <CardContent>
                <Typography variant="title" gutterBottom className={this.props.classes.title} color="textSecondary">
                  Document(s)
                </Typography>
                {("documents" in this.props.report && "surveys" in this.props.report) && <SortableList report={this.props.report} handleFileRemove={this.props.handleFileRemove} handleTreeChange={this.props.handleTreeChange} displayConfirmation={this.props.displayConfirmation} data={[...this.props.report.documents, ...this.props.report.surveys]}/>}

                <FormControl margin="normal" required fullWidth>
                  <input
                    accept="image/*"
                    className={this.props.classes.input}
                    onChange={this.props.handleFileChange}
                    id="path"
                    name="path"
                    type="file"
                  />
                <label htmlFor="path">
                    <Button variant="outlined" component="span" >
                      Ajouter un document
                    </Button>
                  </label>
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                    <FormDialog report={this.props.report}/>
                </FormControl>
              </CardContent>
            </Card>
          </Grid>

          {'audit' in this.props.report && (
          <Grid item xs={12} sm={12} md={6}>
            <Card className={this.props.classes.card}>
              <CardContent>
                <Typography variant="title" gutterBottom className={this.props.classes.title} color="textSecondary">
                  Informations sur l'audit :
                </Typography>

                <Grid container spacing={24}>

                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary">
                      {"Audit prévu " + moment(this.props.report.audit.date).calendar() + " au " + this.props.report.audit.address }
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Qualification(s) :
                    </Typography>
                    <List>
                      {this.props.report.audit.qualifications.map(qualification => (
                        <ListItem key={qualification.id}>
                          <Tooltip title={qualification.description}>
                            <ListItemText
                              primary={qualification.reference + " - " + qualification.name}
                            />
                          </Tooltip>
                        </ListItem>
                      ))}
                    </List>
                    <Typography variant="body2" color="textSecondary">
                      Mention(s) :
                    </Typography>
                    <List>
                      {this.props.report.audit.mentions.map(mention => (
                        <ListItem key={mention.id}>
                          <Tooltip title={mention.description}>
                            <ListItemText
                              primary={mention.reference + " - " + mention.name}
                            />
                          </Tooltip>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="title" gutterBottom className={this.props.classes.title} color="textSecondary">
                      Télécharger le rapport :
                    </Typography>
                    <div className={this.props.classes.wrapper}>
                      <Button
                        variant="contained"
                        color="primary"
                        className={buttonClassname}
                        disabled={this.props.downloading}
                        onClick={() => this.props.downloadReport(this.props.report.id)}
                      >
                        <GetAppIcon/>
                        Télécharger
                        {this.props.downloading && <CircularProgress size={24} className={this.props.classes.buttonProgress} />}
                      </Button>

                    </div>
                  </Grid>

                </Grid>

              </CardContent>
            </Card>
          </Grid>
          )}


        </Grid>
        )}

      </React.Fragment>
    );
  }
}

Report.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Report);



// WEBPACK FOOTER //
// ./src/component/report/report.js